import React, {FC, useEffect, useState} from "react";
import {useTypedSelector} from "../reducers";
import {useForm} from "react-hook-form";
import {UserInterface} from "../model/UserInterface";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {handleError} from "../error/ErrorHandler";

const ShineMyInfoEdit: FC = () => {
    const {loginUser} = useTypedSelector(state => state.auth);
    const { register, handleSubmit, getValues, formState: { errors } } = useForm();
    const [isSendEmail, setIsSendEmail] = useState(false);
    const [isApproveEmail, setIsApproveEmail] = useState(false);
    const [isEmailChanged, setIsEmailChanged] = useState(false);
    const [selectOptionVisible, setSelectOptionVisible] = useState("show")
    const [usrEmail = loginUser?.usrEml?.substring(0, loginUser?.usrEml?.indexOf('@')), setUsrEmail] = useState("");
    const [usrEmlExtension = loginUser?.usrEml?.substring(loginUser?.usrEml?.indexOf('@')+1, loginUser?.usrEml?.length), setUsrEmlExtension] = useState("")
    const [currentUsrEmlYn = loginUser?.emlYn, setCurrentUsrEmlYn] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        setUsrChangeableData();
    }, []);

    const setUsrChangeableData = () => {
        const emlYn : any  = loginUser?.emlYn;
        const email: any = loginUser?.usrEml?.substring(0, loginUser?.usrEml?.indexOf('@'));
        const emailExt: any = loginUser?.usrEml?.substring(loginUser?.usrEml?.indexOf('@')+1, loginUser?.usrEml?.length);
        setCurrentUsrEmlYn(emlYn);
        setUsrEmail(email);
        setUsrEmlExtension(emailExt);
    }

    // 마이정보 변경
    const modifyMydata = async (data: UserInterface | any) => {
        const isPwValid = checkIfPasswordMatchers(data);
        if (!isPwValid) {
            alert('비밀번호를 확인해주세요.')
        } else if (!isApproveEmail && isEmailChanged) {  // 이메일 변경 시도가 있었지만 인증받지 않은 이메일인 경우
            alert('이메일인증을 완료해주세요.');
        } else {
            let email = data.usrEml === null || data.usrEml !== '' ? usrEmail : data.usrEml;
            let emailExt = data.usrEmlExtension === null || data.usrEmlExtension !== '' ? usrEmlExtension : data.usrEmlExtension

            const userEmailData : any = {
                usrEml: email + '@' + emailExt,
                emlYn:  data.emlYn === null || data.emlYn !== '' ? currentUsrEmlYn : data.emlYn,
                usrId: loginUser?.usrId
            }
            try {
                await axios.put('/api/user/update', userEmailData);
                if (data.usrPw !== '') {
                    const userPwData : any = {
                        usrPw: data.usrPw,
                        usrId: loginUser?.usrId
                    }
                    await axios.put('/api/user/password', userPwData);
                    console.log('password 업데이트')

                }
                alert('성공적으로 수정했습니다.');
                navigate('/');
            } catch(err) {
                handleError(err);
            }
        }
    }

    const checkIfPasswordMatchers = (data: any) => {
        if (data.usrPw === data.usrPwAgain) return true;
        return false;
    }

    const onChangeUsrEmail = (e: any) => {
        setUsrEmail(e.target.value);
        setIsEmailChanged(true);
        setIsApproveEmail(false); // 이미 이메일인증 받았더라도 이메일 변경시에 미유효함으로 변경
    }

    const onChangeUsrEmailExtension = (e: any) => {
        checkEmailOptOrSelfExt(e.target.value);
        setIsApproveEmail(false); // 이미 이메일인증 받았더라도 이메일 변경시에 미유효함으로 변경
    }

    const onChangeEmailYn = (e: any) => {
        setCurrentUsrEmlYn(e.target.value);
    }

    const checkEmailOptOrSelfExt = (emailExtension: string) => {
        if (emailExtension === 'naver.com'|| emailExtension ==='gmail.com' || emailExtension ==='hanmail.net') {
            setSelectOptionVisible('hide')
            setUsrEmlExtension(emailExtension);
        } else if (emailExtension === 'self') {
            setSelectOptionVisible('show');
            setUsrEmlExtension('');
        } else {
            setSelectOptionVisible('show');
            setUsrEmlExtension(emailExtension);
        }
    }

    const sendMail = async (event: any) => {
        event.preventDefault();
        try {
            if(!usrEmail || !usrEmlExtension) return alert('이메일을 입력해주세요.');
            const mail = usrEmail?.concat('@').concat(usrEmlExtension);
            //너무 오래걸려서 일단 전송했다고 알림
            setIsSendEmail(true);
            alert('메일로 인증번호를 전송하였습니다.');
            const res = await axios.post('/api/mail/send/verification-code', { receivers: [ mail ]});
            if (res.status !== 200) {
                setIsSendEmail(false);
                throw new Error();
            }
        } catch(err) {
            alert('메일 전송에 실패했습니다.');
        }
    }

    const checkVerificationCode = async () => {
        const verificationCode = getValues("verificationCode");
        if (!verificationCode) return alert('인증번호를 입력해주세요.');
        try {
            const res = await axios.post('/api/mail/check/verification-code', { verificationCode });
            if (res.status !== 200) throw new Error();
            setIsApproveEmail(true);
            alert('인증에 성공했습니다.');
        } catch(err) {
            setIsApproveEmail(false);
            alert('인증에 실패했습니다.');
        }
    }

    const goToMain = (event: any) => {
        event.preventDefault();
        navigate('/')
    }
    return (
        <form onSubmit={handleSubmit(modifyMydata)}>

        <div className={'join-page-wrapper wrapper'}>
            <div className={'join-page-content content'}>
                <div className={'join-page-component-wrapper'}>

                    <div className={'join-input-wrapper'}>
                        <div className={'join-input-content'}>
                            <div className={'join-input-header-wrapper flex-space-between'}>
                                <span className={'join-input-header-title'}>회원정보</span>
                            </div>
                            <div className={'join-input-form-wrapper'}>
                                <div className={'join-input-form-content'}>
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    이름
                                </span>
                                            <input type={'text'} className={'join-input-text'}
                                                   value={loginUser?.usrNm || ''} readOnly/>
                                        </label>
                                    </div>
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    아이디
                                </span>
                                            <input type={'text'} className={'join-input-text'}
                                                   value={loginUser?.usrId || ''} readOnly/>
                                        </label>
                                    </div>
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    새로운 비밀번호
                                </span>
                                            <input type={'password'} className={'join-input-text md'} placeholder={'변경하시려면 입력해주세요.'} {...register("usrPw",
                                                {
                                                    minLength: {
                                                        value: 8,
                                                        message: "최소 8자리 이상 입력해주세요."
                                                    },maxLength: {
                                                        value: 30,
                                                        message: "최대 30자리 이하 입력해주세요."
                                                    },
                                                })}/>
                                            {errors.usrPw && <span className={'error-msg'}>{errors.usrPw.message}</span>}
                                            <span className={'join-input-form-item-desc'}>
                                   8-30자의 영문 소문자, 숫자를 조합하여 입력해주세요.
                                </span>
                                        </label>
                                    </div>
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    비밀번호 확인
                                </span>
                                            <input type={'password'} className={'join-input-text md'} {...register("usrPwAgain")}/>
                                        </label>
                                    </div>
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    소속기관
                                </span>
                                            <input type={'radio'} name={'orgYn'} value={'N' } checked={loginUser?.orgYn === 'N'} readOnly/> 개인
                                            <input type={'radio'} name={'orgYn'} value={'Y' } checked={loginUser?.orgYn === 'Y'} readOnly /> 컨소시움 참여 기관
                                        </label>
                                    </div>
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    기관명
                                </span>
                                            <input type={'text'} className={'join-input-text'}
                                                   value={loginUser?.orgNm || ''} readOnly/>
                                        </label>
                                    </div>
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    이메일
                                </span>
                                            <input type={'text'} className={'join-input-text md'} value={usrEmail || ''}
                                                   {...register("usrEmail")}  onChange={onChangeUsrEmail}/>
                                            &nbsp;@&nbsp;
                                            <input type={'text'} className={`join-input-text sm ${selectOptionVisible === 'show' ? '' : 'no-show'}`}
                                                   value={usrEmlExtension || ''} onChange={onChangeUsrEmailExtension} />
                                            <select className={'join-input-text sm'} style={{marginLeft: '3px'}} onChange={onChangeUsrEmailExtension} defaultValue={usrEmlExtension || ''}>
                                                <option value={'self'}>직접입력</option>
                                                <option value={'naver.com'} id={'naver'}>naver.com</option>
                                                <option value={'gmail.com'} id={'gmail'} >gmail.com</option>
                                                <option value={'hanmail.net'} id={'hanmail'}>hanmail.net</option>
                                            </select>
                                            <button className={'join-agree-button'} onClick={sendMail}>메일인증</button>
                                        </label>
                                    </div>
                                    { isSendEmail &&
                                    <div className={'join-input-form-item'}>
                                        <label>
                                    <span className={'join-input-form-item-label'}>
                                        이메일 인증
                                    </span>

                                            <input type={'text'} placeholder="인증번호" className={'join-input-text md'}  {...register("verificationCode")} />
                                            <button type="button" className={'join-agree-button'} onClick={checkVerificationCode}>확인</button>
                                        </label>
                                    </div>
                                    }
                                    <div className={'join-input-form-item'}>
                                        <label>
                                <span className={'join-input-form-item-label'}>
                                    메일 수신여부
                                </span>
                                            <input type={'radio'} value={'Y'} checked={currentUsrEmlYn === 'Y'} {...register("emlYn")} onChange={onChangeEmailYn}/> 예
                                            <input type={'radio'} value={'N'} checked={currentUsrEmlYn === 'N'} {...register("emlYn")}  onChange={onChangeEmailYn}/> 아니오
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className={'join-button-wrapper flex-center'}>
                                <div className={'join-button-content flex-space-between'}>
                                    <button className={'join-button cancel'} onClick={goToMain}>취소</button>
                                    <button className={'join-button confirm'}>변경</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </form>
    )
}

export default ShineMyInfoEdit;
